import ApiService, { callCustomMethodAsync } from "../service/ApiService";

let moduleApi = {};
let moduleName = "employee_role";

moduleApi.create = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter,loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: (loading == undefined ? false : loading ),
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: { id: id }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.getListEmployeeHasApproveRequest = async data => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "getListEmployeeHasApproveRequest",
    value: { cId: data.cId }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.getListEmployeeHasApproveSalaryPeriod = async data => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "getListEmployeeHasApproveSalaryPeriod",
    value: { data }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

// moduleApi.getAllFeaturesOfEmployee = async data => {
//   let api = {
//     module: moduleName,
//     type: "views",
//     viewAction: "getAllFeaturesOfEmployee",
//     value: { data }
//   };

//   const result = await ApiService(api);
//   mushroom[moduleName].invalidCache();
//   return result;
// };

// moduleApi.getAllFeaturesOfCustomerOrAdmin = async data => {
//   let api = {
//     module: moduleName,
//     type: "views",
//     viewAction: "getAllFeaturesOfCustomerOrAdmin",
//     value: data
//   };

//   const result = await ApiService(api);
//   mushroom[moduleName].invalidCache();
//   return result;
// };

moduleApi.getAllFeaturesOfEmployee = async () => {
  let api = {
    module: moduleName,
    type: "getAllFeaturesOfEmployee",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.getAllFeaturesOfCustomerOrAdmin = async (data) => {
  let api = {
    module: moduleName,
    type: "getAllFeaturesOfCustomerOrAdmin",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

export default moduleApi;
